import { createSelector } from 'reselect';
import { getCompanySettings } from './getCompanySettings';
import { getIsMESEnabled } from './getIsMESEnabled';

/** Returns true when labor tickets are enabled (always true for MES-enabled machines). */
const getIsLaborTicketEnabled = createSelector(
  [getCompanySettings, getIsMESEnabled],
  (companySettings, mesEnabled) => {
    if (mesEnabled) return true;
    // When the company runs MES, labor tickets are governed per-machine via
    // getIsMESEnabled above. A machine without machine-level MES uses the
    // legacy flow and must not inherit the company-wide laborTicketEnabled flag.
    if (companySettings?.mesEnabled === true) return false;
    return companySettings?.laborTicketEnabled ?? false;
  }
);

export { getIsLaborTicketEnabled };
